// extracted by mini-css-extract-plugin
module.exports = {"root":"IconTick_root__2rO-v"};